import type { Language } from "@app/constants";

interface Messages {
	change: string;
	heading: string;
	tooltip: {
		password: string;
	};
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		change: "Change",
		heading: "Password",
		tooltip: {
			password: "Current password (does not contain actual password)",
		},
	},
};

export default messages;
